import { JobWithShare } from "@/lib/supabase/supabaseTypes";
import {
	JobDocumentTypeEnum,
	mapJobDocumentTypeToColor,
	jobDocumentTypeToTagText,
	jobDocumentTypeToText,
} from "./job-document.types";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MouseEventHandler } from "react";

const JobDocumentTag: React.FC<{ type: JobDocumentTypeEnum }> = ({ type }) => {
	const textColor = mapJobDocumentTypeToColor[type];
	return (
		<Tooltip title={jobDocumentTypeToText[type]}>
			<span
				className="text-[11px] font-medium text-center items-center justify-center rounded-sm px-1.5 py-0.5 text-white"
				style={{ backgroundColor: textColor }}
			>
				{jobDocumentTypeToTagText[type]}
			</span>
		</Tooltip>
	);
};

export const JobDocumentTags: React.FC<{ job: JobWithShare}> = ({
	job,
}) => {
	const types = job.job_document_types
	const navigate = useNavigate()

	const handleNavigation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		e.stopPropagation()
		navigate(`/client/${job.client_id}/job/${job.id}`)
	}

	return (
		<div className="flex items-center gap-1 cursor-pointer" onClick={(e)=> handleNavigation(e)}>
			{types
				?.filter((type) => type !== JobDocumentTypeEnum.Tracing)
				.map(
					(type) =>
						type && (
							<JobDocumentTag
								key={type}
								type={type as JobDocumentTypeEnum}
							/>
						)
				)}
		</div>
	);
};
